export default __webpack_public_path__ + "static/media/Ritij.77bb0fcc.jpeg";